import React from 'react';
import {MainFooterBlock} from '../main/blocks/MainFooterBlock/MainFooterBlock';
import {CabinetMainMenu} from '../cabinet/blocks/CabinetMainMenu/CabinetMainMenu';
import {CabinetLeftMenu} from '../cabinet/blocks/CabinetLeftMenu/CabinetLeftMenu';
import ApvgkMainPage from '../apvgk/main/ApvgkMainPage';
import TrackPageView from "../admin/track/TrackPageView";
import {roleConstants} from "../../constants/roleConstants";
import {AuthRoute} from "../../components/routes/AuthRoute";
import ApvgkMonitorPage from "./ApvgkMonitorPage";

const GibddLayout = ({ match }) => {
  const links = [
    { key: 1, path: `${match.url}`, title: 'Личный кабинет', hasChild: false },
    {
      key: 2,
      path: `${match.url}/track`,
      title: 'Проезды',
      hasChild: false
    },
    {
      key: 3,
      path: `/monitor`,
      title: 'Монитор',
      hasChild: false
    }
  ];

  return (
    <div className="">
      <div className="cabinet-header">
        <CabinetMainMenu />
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3">
            <div className="cabinet-left-menu">
              <CabinetLeftMenu links={links} />
            </div>
          </div>

          <div className="col-md-9 cabinet-content">
            <AuthRoute roles={[roleConstants.ROLE_GIBDD_HIDDEN]} exact path={`${match.url}`} component={ApvgkMainPage} />
            <AuthRoute roles={[roleConstants.ROLE_GIBDD_HIDDEN]} path={`${match.url}/track`} component={TrackPageView} />
          </div>
        </div>
      </div>
      <MainFooterBlock />
    </div>
  );
};

export default GibddLayout;
